/**
 * ToolCallExpand — kollabierbarer Tool-Aufruf-Block (#1180).
 */
import { useState } from 'react';
import { ChevronDown, ChevronRight, Wrench, CheckCircle2, AlertCircle } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

function tryParseJson(s) {
  if (typeof s !== 'string') return s;
  try { return JSON.parse(s); } catch { return s; }
}

function formatJson(v) {
  try {
    return JSON.stringify(v, null, 2);
  } catch {
    return String(v);
  }
}

export default function ToolCallExpand({ call }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);

  const isError = !!call.isError;
  const output = tryParseJson(call.output);
  const rowsInfo = output && typeof output === 'object' && typeof output.rows_returned === 'number'
    ? t('chat.rows_returned', { count: output.rows_returned })
    : null;

  return (
    <div className={`my-2 border rounded-[10px] overflow-hidden ${isError ? 'border-red-200 bg-red-50/30 dark:border-red-500/30 dark:bg-red-500/10' : 'border-line bg-surface-input/50'}`}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full px-3 py-2 flex items-center gap-2 text-sm text-left hover:bg-surface-hover transition-colors"
      >
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        {isError ? <AlertCircle size={14} className="text-red-500" /> : <Wrench size={14} className="text-[#338edc]" />}
        <span className="font-mono font-medium text-[var(--text-primary)]">{call.name}</span>
        {call.durationMs != null && (
          <span className="text-xs text-[var(--text-tertiary)] ml-1">
            {t('chat.duration_ms', { ms: call.durationMs })}
          </span>
        )}
        {rowsInfo && (
          <span className="text-xs text-[var(--text-tertiary)]">· {rowsInfo}</span>
        )}
        {!isError && call.output != null && (
          <CheckCircle2 size={12} className="text-green-500 ml-auto" />
        )}
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2 border-t border-line">
          <div>
            <div className="text-[11px] uppercase tracking-wide text-[var(--text-tertiary)] mt-2 mb-1">
              {t('chat.tool_call') || 'Tool-Aufruf'}
            </div>
            <pre className="text-xs font-mono bg-[#0f172a] text-gray-100 rounded-[6px] p-2 overflow-x-auto max-h-40">
              {formatJson(call.input)}
            </pre>
          </div>
          {call.output != null && (
            <div>
              <div className="text-[11px] uppercase tracking-wide text-[var(--text-tertiary)] mb-1">
                {isError ? (t('chat.tool_blocked') || 'Blockiert') : (t('chat.tool_result') || 'Ergebnis')}
              </div>
              <pre className="text-xs font-mono bg-[#0f172a] text-gray-100 rounded-[6px] p-2 overflow-x-auto max-h-80">
                {typeof output === 'string' ? output : formatJson(output)}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
